'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Dom = function () {
  function Dom(doc) {
    _classCallCheck(this, Dom);

    this.document = doc || window.document;
  }

  /**
   * Create a DOM element
   *
   * @param string        type        Type of DOM node to create
   * @param array         attributes  Optional. Map of attributes to add.
   * @param array||string children    Array of DomNodes to apppend to the new element or a string text to add
   * @return DomNode
   */


  _createClass(Dom, [{
    key: 'createElement',
    value: function createElement(type, attributes, children) {
      var element = this.document.createElement(type);

      if (attributes) {
        this.setAttributes(element, attributes);
      }

      if (children) {
        // Add text or child elements
        if (typeof children === 'string') {
          var text = this.document.createTextNode(children);
          element.appendChild(text);
        } else {
          children.forEach(function (child) {
            element.appendChild(child);
          });
        }
      }

      return element;
    }

    /**
     * Create an element from a HTML string
     *
     * @param string html
     * @return DomNode
     */

  }, {
    key: 'createElementFromHtml',
    value: function createElementFromHtml(html) {
      var element = this.document.createElement("template");
      element.insertAdjacentHTML('afterbegin', html);

      var firstChild = element.firstChild;
      while (firstChild != null && firstChild.nodeType == 3) {
        firstChild = firstChild.nextSibling;
      }

      return firstChild;
    }
  }, {
    key: 'getBody',
    value: function getBody() {
      return this.document.body;
    }
  }, {
    key: 'getElementById',
    value: function getElementById(id) {
      return this.document.getElementById(id);
    }
  }, {
    key: 'setAttributes',
    value: function setAttributes(element, attributes) {
      for (var attribute in attributes) {
        element.setAttribute(attribute, attributes[attribute]);
      }

      return element;
    }
  }]);

  return Dom;
}();

exports.default = Dom;
module.exports = exports['default'];